import { LinkBuilder } from '../link-builder.service';
import { UserService } from '../user/user.service';

export class DebtRecoveryService {

  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.ChargeAccounts.ChargeAccount | InterACT.Interfaces.ChargeAccounts.ChargeAccountActionsResponse>>;

  constructor(
    $resource: ng.resource.IResourceService,
    private linkBuilder: LinkBuilder,
    private userService: UserService) {
    this.resource = $resource('api/debt-recovery');
  }

  /**
   * A method to create an action to recover debt
   * @param chargeAccountId the charge account to recover debt from
   */
  public recoverDebtForChargeAccount(chargeAccountId: string) {
    let schemeLink = this.linkBuilder.getSchemesLink(
      this.userService.selectedScheme.id
    );
    let chargeAccountAction: InterACT.Interfaces.ChargeAccounts.ChargeAccountAction = {
      actionType: 'RECOVER_DEBT',
      status: 'PENDING',
      scheme: {
        abbreviation: (<any>this.userService.selectedScheme).abbreviation,
        link: schemeLink
      },
      chargeAccount: {
        link: this.linkBuilder.getChargeAccountLink(chargeAccountId)
      },
      reason: 'DEBT_RECOVERY'
    };
    return this.resource.save(chargeAccountAction).$promise;
  }
}